import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { EMPTY, map, Observable, take } from 'rxjs';
import { LicenseDependentButtonModel } from '../../models/license-dependent-button.model';
import { LicenseResultModel } from '../../models/license.result.model';
import { PaymentSummaryModel } from '../../models/payment-summary.model';
import { PaymentType } from '../../models/payment-type.enum';
import { GgsCompanyService } from '../../services/ggs-company.service';
import { LanguageService } from '../../services/language.service';
import { LicenseService } from '../../services/license.service';
import { TOOL_KEY } from '@hazmatsuite-next/shared';

@Component({
  selector: 'hazmatsuite-next-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.scss'],
})
export class PaymentSummaryComponent implements OnInit {
  @Input() set model(m: PaymentSummaryModel) {
    this.paymentSummaryModel = m;
    this.creditButtonModel = {
      ...m.LicenseDependentButtonModel,
      PaymentType: PaymentType.Credits
    }
    this.subscriptionButtonModel = {
      ...m.LicenseDependentButtonModel,
      PaymentType: PaymentType.Subscription
    }
  }
  @Output() beforeNavigationAction = new EventEmitter();
  @Output() submitAction = new EventEmitter<PaymentType>();

  paymentSummaryModel = new PaymentSummaryModel();
  subscriptionButtonModel = new LicenseDependentButtonModel();
  creditButtonModel = new LicenseDependentButtonModel();
  licenseResult$: Observable<LicenseResultModel> = EMPTY;

  paymentTranslations$ = this.languageService.translations$.pipe(
    map(data => data['PaymentResources'])
  );

  ggsContact$ = this.ggsService.getCompanyDetails();

  constructor(private licenseService: LicenseService, private languageService: LanguageService, private ggsService: GgsCompanyService, @Inject(TOOL_KEY) public toolkey: string) {
    this.languageService.fetchResources(['PaymentResources']);
  }

  ngOnInit(): void {
    this.licenseResult$ = this.licenseService.checkLicense(this.paymentSummaryModel.LicenseDependentButtonModel, true);
    this.licenseService.savePaymentSummary(this.paymentSummaryModel).pipe(take(1)).subscribe();
  }

  buyWithCredits(): void {
    this.submitAction.emit(PaymentType.Credits);
  }

  buyWithLicense(): void {
    this.submitAction.emit(PaymentType.Subscription);
  }
}
